import type { ElementType } from "react"
import { forwardRef } from "react"

interface LandingChipFeatureProps {
  label: string
  icon: ElementType
  isActive: boolean
  onClick: () => void
  className?: string
}

export const LandingChipFeature = forwardRef<HTMLButtonElement, LandingChipFeatureProps>(
  ({ label, icon: IconComponent, isActive, onClick, className = "" }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        className={`group relative isolate z-20 transition-transform duration-100 active:scale-[0.985] shrink-0 ${className}`}
      >
        {/* Label */}
        <div className="relative z-10 px-4 mr-[.3rem] py-1.5 whitespace-nowrap">
          <span className="inline-flex items-center gap-[.35rem] text-sm font-medium text-white">
            <IconComponent className={`w-3.5 h-3.5 ${isActive ? "text-[#30DFFF] opacity-100" : "opacity-[0.55]"}`} />
            {label}
          </span>
        </div>
        {/* Skewed Background */}
        <div
          className={`absolute inset-0 transform skew-x-[-16deg] rounded-md transition-all duration-150 backdrop-blur-xs ${
            isActive
              ? "bg-[#001CFF]/30 border border-[#001CFF]"
              : "bg-white/11 group-hover:bg-white/15 group-active:bg-white/10 border border-transparent"
          }`}
        />
      </button>
    )
  },
)

LandingChipFeature.displayName = "LandingChipFeature"
